import React, { FunctionComponent, memo, useMemo } from "react";
import { isEqual } from "lodash";

import {
  Th,
  useColorModeValue,
} from "@chakra-ui/react";


interface IProps {
  hours: number[];
  hour?: number;
  cellWidth?: number;
  cellPaddingX?: number;
}


const PredictionHours: FunctionComponent<IProps> = memo(function PredictionHours({
  hours,
  hour = 0,
  cellWidth = 35,
  cellPaddingX = 0,
}) {
  const hourHighlightColor = useColorModeValue("gray.950", "white");
  const nowHour = useMemo<number>(() => hour, [hour]);
  const nowHourIndex = useMemo<number>(() => hours.indexOf(nowHour), [nowHour, hours]);


  return (
    <>
      { hours.map((hour, i) => <Th
          key={hour}
          bg={i === nowHourIndex ? hourHighlightColor : undefined}
          minWidth={`${cellWidth}px`}
          px={`${cellPaddingX}px`}
          textAlign="right"
          fontSize="x-small"
          title={`${i % 24}:00 - ${i % 24}:59`}
        >
          {hour % 24}:
        </Th> ) }
    </>
  );
}, isEqual);

export default PredictionHours;
